module.exports = __webpack_public_path__ + "static/media/business-leaders.fe4b8b56.svg";